import { useEffect, useState } from "react";
import BookList from "../components/books/BookList";
import UploadModal from "../components/books/UploadModal";
import { isAuthenticated } from "../utils/auth";

function Books() {
    const [showUploadModal, setShowUploadModal] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    try {
        
        useEffect(() => {
            if (!isAuthenticated()) {
                window.location.href = '/auth';
                return;
            }
        }, []);

        // Function to handle opening upload modal
        const handleOpenUpload = () => {
            if (isAdmin) {
                setShowUploadModal(true);
            }
        };

        return (
            <div className="container mx-auto px-4 py-8" data-name="books-page">
                <div className="flex justify-between items-center mb-8">
                    <h1 className="text-3xl font-bold" data-name="page-title">eBook Library</h1>
                    <div className="flex items-center gap-4" data-name="actions">
                        <div className="flex gap-4" data-name="filters">
                            <input
                                type="search"
                                placeholder="Search books..."
                                className="input max-w-xs"
                                data-name="search-input"
                            />
                            <select className="input max-w-xs" data-name="category-filter">
                                <option value="">All Categories</option>
                                <option value="fiction">Fiction</option>
                                <option value="non-fiction">Non-Fiction</option>
                                <option value="science">Science</option>
                                <option value="technology">Technology</option>
                            </select>
                        </div>
                        {isAdmin && (
                            <button 
                                className="btn btn-primary"
                                onClick={handleOpenUpload}
                                data-name="upload-button"
                            >
                                <i className="fas fa-upload mr-2"></i>
                                Upload PDF
                            </button>
                        )}
                    </div>
                </div>
                <BookList isAdmin={isAdmin} onUpload={handleOpenUpload} />
                {showUploadModal && isAdmin && (
                    <UploadModal onClose={() => setShowUploadModal(false)} />
                )}
            </div>
        );
    } catch (error) {
        console.error('Books page error:', error);
        reportError(error);
        return null;
    }
}

export default Books;